import { createContext, ReactNode, useEffect, useState } from "react"
import { hexToHsl } from "../services/functions"

type ColorType = {
    button: string // Tailwind -> secondary
    text: string // Tailwind -> primary
    bg1: string // Tailwind -> bg-base-1
    bg2: string // Tailwind -> bg-base-2
    bg3?: string // Tailwind -> bg-base-3
    in?:string // Tailwind --> info
}

type ThemeContextType = {
    color?: ColorType
    setcolor: (e: ColorType) => void
    textColor: string
    settextColor: (e: string) => void
    headlineColor: string
    setheadlineColor: (e: string) => void
}

type ThemeContextProviderProps = {
    children: ReactNode
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export const ThemeContextProvider = ({ children }: ThemeContextProviderProps) => {
    const [color, setcolor] = useState<ColorType>()
    const [headlineColor, setheadlineColor] = useState<string>("text-accent")
    const [textColor, settextColor] = useState<string>("text-neutral")

    useEffect(() => {
        document.documentElement.style.setProperty("--headline", `${color?.text.trim()}`)
        document.documentElement.style.setProperty("--p", hexToHsl(`${color?.text.trim()}`))
        document.documentElement.style.setProperty("--s", hexToHsl(`${color?.button.trim()}`))
        document.documentElement.style.setProperty("--b1", hexToHsl(`${color?.bg1.trim()}`))
        document.documentElement.style.setProperty("--b2", hexToHsl(`${color?.bg2.trim()}`))
        document.documentElement.style.setProperty("--b3", hexToHsl(`${color?.bg3?.trim()}`))
        document.documentElement.style.setProperty("--in", hexToHsl(`${color?.in?.trim()}`))
    }, [color])

    return (
        <ThemeContext.Provider value={{ color, setcolor, textColor, settextColor, headlineColor, setheadlineColor }}>
            {children}
        </ThemeContext.Provider>
    )
}
